import { defineStore } from 'pinia'
import { useAsyncRequest } from '@/composables/useAsyncRequest'

export const useCartAddOnsStore = defineStore('cartAddOns', () => {
    const { loading, error, request } = useAsyncRequest()

    const addOns = ref([])

    const loadAddOns = async () => {
        const response = await request('get', '/api/cart/add-ons')
        addOns.value = response.data ?? []
    }

    return {
        addOns,
        loadAddOns,
        loading,
        error
    }
})
